// Firestore updates often use dotted paths like "JFS Vancouver.latitude". Depending on
// how data was written, those fields can appear as top-level keys whose values are
// primitives. Object.keys() then yields "JFS Vancouver.latitude" alongside "JFS Vancouver",
// and map code that expects each value to be a location object breaks (undefined lat/lng).
export default function normalizeDistributionLocationsDoc(data) {
  if (!data || typeof data !== "object") {
    return {};
  }
  const out = { ...data };
  const merges = [];

  Object.keys(out).forEach((key) => {
    if (typeof key !== "string" || !key.includes(".")) {
      return;
    }
    const dot = key.indexOf(".");
    const parent = key.slice(0, dot);
    const field = key.slice(dot + 1);
    if (!parent || !field) {
      return;
    }
    merges.push([parent, field, out[key]]);
    delete out[key];
  });

  merges.forEach(([parent, field, val]) => {
    const existing = out[parent];
    const base =
      existing && typeof existing === "object" && !Array.isArray(existing)
        ? { ...existing }
        : {};
    out[parent] = { ...base, [field]: val };
  });

  return out;
}
